const RELOADED_AT = "nudgebox:stale-chunk-reload";
/** A second failure within this window is a real outage, not a stale tab; don't loop. */
const RETRY_WINDOW_MS = 30_000;

/**
 * A tab opened before a deploy still references the previous build's hashed chunks, which the
 * new deploy removed. When Vite fails to preload one, reload once to pick up the current build.
 */
export function reloadOnStaleChunks() {
  window.addEventListener("vite:preloadError", (event) => {
    try {
      if (Date.now() - Number(sessionStorage.getItem(RELOADED_AT) ?? 0) < RETRY_WINDOW_MS) return;
      sessionStorage.setItem(RELOADED_AT, String(Date.now()));
    } catch {
      // Without storage there is no loop guard, so let the error surface instead.
      return;
    }
    event.preventDefault();
    window.location.reload();
  });
}
